import React, { useState, useEffect } from 'react';
import { MotivationalMessageCard } from '../../components/captain-overview/MotivationalMessageCard';
import { CompactWeatherWidget } from '../../components/captain-overview/CompactWeatherWidget';
import { InternalMessagesPanel } from '../../components/captain-overview/InternalMessagesPanel';
import { MissionVisionValues } from '../../components/captain-overview/MissionVisionValues';
import './CaptainOverviewPage.css';
import AIAgentKpiWidget from '../../components/captain-overview/AIAgentKpiWidget';

export const CaptainOverviewPage: React.FC = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="captain-overview-page">
      {/* Header with Weather */}
      <div className="captain-header">
        <div className="captain-logo-section">
          <img 
            src="/captain-mascot.png" 
            alt="Captain Right Away" 
            className="captain-mascot"
          />
        </div>
        <CompactWeatherWidget />
        <div className="captain-date-time">
          <div className="captain-date">
            {new Date().toLocaleDateString('en-US', { 
              weekday: 'long', 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </div>
          <div className="captain-time">
            {currentTime.toLocaleTimeString('en-US', {
              hour: 'numeric',
              minute: '2-digit',
              second: '2-digit',
              hour12: true
            })}
          </div>
        </div>
      </div>

      {/* Main Content Grid */}
      <div className="captain-content">
        {/* AI Agent KPIs */}
        <div className="captain-section full-width">
          <AIAgentKpiWidget />
        </div>

        {/* Top: Mission, Vision & Values */}
        <div className="captain-section full-width">
          <MissionVisionValues />
        </div>

        {/* Company Messages */}
        <div className="captain-section full-width">
          <InternalMessagesPanel />
        </div>

        {/* Motivational Message */}
        <div className="captain-section full-width">
          <MotivationalMessageCard />
        </div>
      </div>

      {/* Footer */}
      <div className="captain-footer">
        <p>© {new Date().getFullYear()} Command Center - Serving Florida with Excellence</p>
      </div>
    </div>
  );
};
